import React from 'react';
import { SvgIcon } from '@material-ui/core';

const AiIcon = (props) => {
  return (
      <img class="homeicon" viewBox="0 0 24 24" src="./images/ai.svg" alt="" />
  );
};

export default AiIcon;
